// Storage Keys
export const APP_STORAGE = {
  ACCESS_TOKEN: 'access_token',
  ID_TOKEN: 'id_token',
};
